<template>
	<div class="reply contains">
		<div class="service">
			<div data-v-2b214c9a class="tac" style="width: 20%;">
				<el-col :span="24" class="warpper">
					<!-- <el-menu default-active="1" class="el-menu-vertical-demo" @select="choose">
								<el-menu-item index="-1" @click="addGroupVisible = true">
									<span slot="title">
										个人组库
										<i class="el-icon-circle-plus"></i>
									</span>
								</el-menu-item>
								<el-menu-item @click="QuickGroupSelected({id:0})">
									<span>全部</span>
								</el-menu-item>
								<el-menu-item
									:index="item.id.toString()"
									v-for="(item,index) in groupList"
									@click="QuickGroupSelected(item)"
								>
									<span slot="title">{{item.groupName}}</span>
								</el-menu-item>
					</el-menu>-->
					<el-tree
						@node-click="NodeClisk"
						:data="quickTree"
						ref="tree"
						node-key="id"
						:expand-on-click-node="false"
						:render-content="renderContent"
						v-loading="fetchLoding"
						:highlight-current="true"
					></el-tree>
				</el-col>
			</div>

			<div data-v-2b214c9a class="tabs" style="width: 80%;">
				<div data-v-2b214c9a class="tab-option">
					<div class="content-tit">
						<div class="flex-box">
							<h2>公共库</h2>
							<el-tooltip class="item" effect="dark" content="下载导入模板">
								<el-button
									class="item import"
									icon="el-icon-download"
									@click="downloadTemplate"
									style=" color: #909399;
											background: #f4f4f5;
											border-color: #d3d4d6;"
								></el-button>
							</el-tooltip>
							<el-button
								type="info"
								plain
								class="delete"
								@click="CheckDelete"
								v-bind:disabled="iSdelete"
							>删除</el-button>
							<el-button type="info" plain class="export" @click="export1">导出</el-button>
							<!-- <el-button type="info" plain class="import" @click="tolead">导入</el-button> -->
							<el-tooltip
								class="item import"
								effect="dark"
								content="请先选择类别导入"
								placement="top-start"
								style="    color: #909399;
											background: #f4f4f5;
											border-color: #d3d4d6;"
							>
								<el-button @click="tolead">导入</el-button>
							</el-tooltip>
							<el-upload
								class="upload-demo"
								:action="importDefaultsUrl"
								:on-success="uploadExcel"
								:on-error="uploadExcelErr"
								:before-upload="uploadExcelChange"
								:data="importData"
								multiple
								ref="uploadShow"
								:limit="3"
								:show-file-list="false"
								v-show="false"
							></el-upload>

							<el-button type="primary" class="add" @click="AddShow" style="    margin-left: 10px;">添加新问题</el-button>
							<el-input placeholder="搜索快捷回复" v-model="value1">
								<el-button slot="append" icon="el-icon-search" @click="Select"></el-button>
							</el-input>
							<div class="clear"></div>

							<el-dialog :title="UpdateModelUpdate" :visible.sync="dialogVisible" width="30%">
								<div class="dialog">
									<div class="section">
										<span class="label">类别</span>
										<div class="input_box">
											<el-select
												v-model="QuickReply.GroupId"
												placeholder="请选择"
												class="input"
												disabled="disabled"
											>
												<el-option
													v-for="item in options"
													:key="item.value"
													:label="item.name"
													:value="item.id"
												></el-option>
											</el-select>
										</div>
										<div class="clear"></div>
									</div>
									<div class="section">
										<span class="label">快捷词</span>
										<div class="input_box">
											<el-input placeholder="请输入内容" v-model="QuickReply.KeyWord" class="input">
												<template slot="prepend">#</template>
											</el-input>
										</div>
										<div class="clear"></div>
									</div>
									<div class="section">
										<span class="label">回复内容</span>
										<div class="input_box">
											<el-input
												type="textarea"
												v-model="QuickReply.Content"
												class="input textarea"
												placeholder="请输入内容"
												resize="none"
												maxlength="150"
												show-word-limit
											></el-input>

											<i
												class="iconfont icon-biaoqing emoji_box"
												@click="show4=!show4"
												style="font-size: 24px;"
											></i>
											<div id="emoji1" v-if="show4">
												<div
													class="el-tabs__content"
													v-for="(emojiCon, emojiKey, eInd) in emojiIcon"
													v-if="eInd == eindex"
													:key="emojiKey"
													:label="emojiKey"
													:name="emojiKey"
													style="display: inline;"
												>
													<span
														@click="choose(emoItem)"
														:key="emoInd"
														v-for="(emoItem, emoInd) in emojiCon"
														v-html="emoItem.emoji"
													></span>
												</div>
											</div>
										</div>

										<div class="clear"></div>
									</div>
								</div>
								<span slot="footer" class="dialog-footer">
									<el-button @click="Clear">取 消</el-button>
									<el-button type="primary" @click="Add" v-if="UpdateModel!=true">确 定</el-button>
									<el-button type="primary" @click="UPdate" v-if="UpdateModel!=false">修改</el-button>
								</span>
							</el-dialog>
						</div>
					</div>

					<div class="content-main">
						<div class="flex-box">
							<div class="table_box">
								<el-table
									:data="tableData"
									style="width: 100%;"
									border
									@select="selectCheck"
									@select-all="select_allCheckk"
								>
									<el-table-column type="selection" width="55"></el-table-column>
									<el-table-column prop="KeyWord" label="快捷词" width="200"></el-table-column>
									<el-table-column prop="Content" label="回复内容"></el-table-column>
									<el-table-column prop="UseCount" label="30天内使用次数" width="200" sortable></el-table-column>

									<!-- <el-table-column prop="operate" label="操作" width="200">
                  <i class="el-icon-edit" style=" cursor: pointer;"></i>
                  <i class="el-icon-delete" style=" cursor: pointer;"></i>
									</el-table-column>-->

									<el-table-column fixed="right" label="操作" width="200">
										<template slot-scope="scope">
											<i class="el-icon-edit" @click="UpdateShow(scope.row.ID)" style="cursor: pointer;"></i>
											<i class="el-icon-delete" style="cursor: pointer;" @click="Delete(scope.row.ID)"></i>
											<!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button>
											<el-button type="text" size="small">编辑</el-button>-->
										</template>
									</el-table-column>
								</el-table>
							</div>
							<div class="pagination">
								<el-pagination
									@current-change="List"
									background
									layout="total, prev, pager, next"
									:total="SumUser"
								></el-pagination>
							</div>
						</div>
					</div>
				</div>
				<!---->
			</div>
		</div>
	</div>
</template>

<script>
let emojiData = require('@/assets/emoji/emoji.json')
import { DateTime } from '@/utils/common'
export default {
	name: 'reply',
	props: [],
	data() {
		return {
			emojiIcon: emojiData.icon,
			eindex: 0,
			importData: {},
			importDefaultsUrl: '',
			quickRequest: {
				keyWord: '',
				groupId: 0,
				pagination: {
					pageIndex: 1,
					pageSize: 10,
					total: 10
				}
			},
			groupId: 0,
			quickReply: {
				groupId: undefined,
				keyWord: '',
				content: '',
				id: 0
			},
			quickTree: [],
			iSdelete: false,
			//选中的删除
			DeleteFastreply: [],
			QuickReply: {
				Id: 0,
				KeyWord: '',
				Content: '',
				UseCount: 0,
				CreateTime: '2019-12-26',
				GroupId: '',
				UpdateTime: '2019-12-26'
			},
			UpdateModel: false,
			UpdateModelUpdate: '添加新的快捷回复',
			value1: '',
			value2: '',
			value3: '',
			tableData: [],
			dialogVisible: false,
			options: [
				{
					value: '选项1',
					label: '黄金糕'
				},
				{
					value: '选项2',
					label: '双皮奶'
				}
			],
			SumUser: 0,
			show4: false
		}
	},
	watch: {},
	mounted: function() {
		this.List(1)
		this.show()
	},
	created: function() {
		this.Total()
		this.getQuickGroups(0)
		this.axios.defaults.baseURL + 'QuickReply/ImportQuick'
		this.importDefaultsUrl =
			this.axios.defaults.baseURL + 'QuickReply/ImportQuick'
	},
	methods: {
		uploadExcelErr() {},
		uploadExcelChange() {},
		uploadExcelChange(val) {
			console.log(val)
			this.importLoading = true
		},
		uploadExcel(val) {
			if (val.result) {
				this.$message({ type: 'success', message: val.message })
				this.List()
				this.Total()
			} else {
				this.$message({ type: 'error', message: val.message })
			}
			this.importLoading = false
		},
		AddQuickGroup(data) {
			let vm = this
			let date = new DateTime()
			this.axios
				.post('QuickReply/AddGroupQuick', {
					type: 0,
					Name: vm.quickGroup,
					Parentid: vm.treeData.id,
					CreateTime: date.Now()
				})
				.then(function(result) {
					if (!result.data.code) {
						vm.$notify.error({
							title: '错误',
							message: data.message
						})
					} else {
						vm.groupId = result.data.id
						const newChild = {
							id: result.data.id,
							label: 'add',
							children: []
						}
						if (!data.children) {
							vm.$set(data, 'children', [])
						}
						data.children.push(newChild)
					}
					vm.addGroupVisible = false
				})
		},
		async append(data) {
			let vm = this
			// debugger
			vm.treeData = data
			// vm.addGroupVisible = true
			await vm.AddQuickGroup(data)
			// let id = vm.groupId
		},
		changeNode(r, node, data) {
			let vm = this
			if (r.target.value != '') {
				data.label = r.target.value
				vm.quickGroup = r.target.value
				vm.treeData = data
				vm.updQuickGroup(data.id, data.label)
			} else {
				data.label = vm.defaultLabel
			}
		},
		updQuickGroup(id, name) {
			let vm = this
			this.axios
				.get('QuickReplyGroup/UpdGroupQuick', {
					params: { id: id, name: name }
				})
				.then(function({ data }) {
					if (data.result) {
						vm.$message({ type: 'success', message: '成功' })
					}
				})
		},
		renderContent(h, { node, data, store }) {
			if (node.label == 'add') {
				return (
					<span class="custom-tree-node">
						<span>
							<input
								class="treeInput"
								v-model={data.label}
								style="width: 100px;"
								on-blur={r => this.changeNode(r, node, data)}
								placeholder="输入组名称"
							></input>
						</span>
						<span>
							<i
								class="el-icon-delete"
								on-click={() => this.deleteGroup(node, data)}
							></i>
						</span>
					</span>
				)
			} else if (data.id == 0) {
				return (
					<span class="custom-tree-node">
						<span>{node.label}</span>
						<span>
							<i
								class="el-icon-plus"
								on-click={() => this.append(data)}
							></i>
						</span>
					</span>
				)
			} else if (node.level > 2) {
				return (
					<span class="custom-tree-node">
						<span>{node.label}</span>
						<span>
							<i
								class="el-icon-edit"
								on-click={() => this.editGroupName(data)}
							></i>
							<i
								class="el-icon-delete"
								on-click={() => this.deleteGroup(node, data)}
							></i>
						</span>
					</span>
				)
			} else {
				return (
					<span class="custom-tree-node">
						<span>{node.label}</span>
						<span>
							<i
								class="el-icon-plus"
								on-click={() => this.append(data)}
							></i>
							<i
								class="el-icon-edit"
								on-click={() => this.editGroupName(data)}
							></i>
							<i
								class="el-icon-delete"
								on-click={() => this.deleteGroup(node, data)}
							></i>
						</span>
					</span>
				)
			}
		},
		//导入模板
		downloadTemplate() {
			let vm = this
			this.axios
				.get('QuickReply/GetImportTemplate', { responseType: 'blob' })
				.then(function(res) {
					let filename = '快捷回复模板.xls'
					let blob = res.data
					let reader = new FileReader()
					reader.readAsDataURL(blob)
					reader.onload = e => {
						//创建a标签，插入到文档中并click，最后移除
						let a = document.createElement('a')
						a.download = filename
						a.href = e.target.result
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
					}
				})
		},
		NodeClisk(val) {
			this.QuickGroupSelected(val)
			this.quickReply.groupIdgroupId = val.id
			this.$refs.tree.store.nodesMap[val.id].expanded = true
			val.unfold = true
			if (val.id == 0) {
				this.QuickReply.GroupId = this.options[0].id
			} else {
				this.QuickReply.GroupId = val.id
			}
		},
		deleteGroup(node, data) {
			let vm = this
			if (data.children.length > 0) {
				this.$alert('请先删除子集', '提示', {
					confirmButtonText: '确定',
					callback: action => {}
				})
				return
			}
			this.axios
				.get('QuickReplyGroup/DeleteGroupQuick', {
					params: {
						quickId: data.id
					}
				})
				.then(function({ data }) {
					if (data.result) {
						vm.$message({ type: 'success', message: '删除成功' })

						const parent = node.parent
						const children = parent.data.children || parent.data
						const index = children.findIndex(d => d.id === data.id)
						children.splice(index, 1)
					} else {
						this.$alert(data.message, '提示', {
							confirmButtonText: '确定',
							callback: action => {}
						})
					}
				})
		},
		editGroupName(data) {
			this.defaultLabel = data.label
			data.label = 'add'
		},
		QuickGroupSelected(val) {
			this.quickRequest.groupId = val.id

			this.List()
			this.Total()

			this.importDefaultsUrl =
				this.axios.defaults.baseURL +
				'QuickReply/ImportQuick' +
				'?groupId=' +
				val.id
		},
		// 		fetchQueryList() {
		// 	let vm = this
		// 	vm.quickListLoading = true
		// 	this.axios
		// 		.post('QuickReply/quickList', vm.quickRequest)
		// 		.then(function({ data }) {
		// 			if (data.result) {
		// 				vm.quickPageList = data.data
		// 				vm.quickRequest.pagination = data.data.pagination
		// 			}
		// 			vm.quickListLoading = false
		// 		})
		// },
		getQuickGroups(typeid) {
			let vm = this
			vm.fetchLoding = true
			this.axios
				.get('QuickReplyGroup/getQuickTree', {
					params: { typeid: typeid }
				})
				.then(function({ data }) {
					if (data.result) {
						vm.quickTree = data.data
					}
					vm.fetchLoding = false
				})
		},
		Total(KeyWord) {
			//初始化  客服总人数
			let $this = this
			var KeyWord1 = $this.value1
			var GroupId1 = $this.quickRequest.groupId

			this.axios
				.get(
					'QuickReply/Sum',
					{
						params: {
							KeyWord: KeyWord1,
							GroupId: GroupId1
						}
					},
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data) {
					$this.SumUser = data.data
				})
		},
		//返回用户列表
		List(PageSize, PageNum, KeyWord) {
			let $this = this
			var KeyWord1 = $this.value1
			var GroupId1 = $this.quickRequest.groupId
			PageNum = 10

			this.axios
				.get(
					'QuickReply/List',
					{
						params: {
							PageSize: PageSize,
							pageNum: PageNum,
							KeyWord: KeyWord1,
							GroupId: GroupId1
						}
					},
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data) {
					$this.tableData = []
					data.data.forEach(element => {
						$this.tableData.push({
							ID: element.id,
							KeyWord: element.keyWord,
							Content: element.content,
							UseCount: element.useCount,
							operate: '未处理'
						})
					})
				})
		},
		Select() {
			let $this = this
			this.List(1, 10, $this.value1)
			this.Total($this.value1)
		},
		//添加
		Add() {
			let $this = this

			var boole = true
			if ($this.QuickReply.KeyWord == '') {
				$this.$message.error('请输入快捷词')
				boole = false
			} else if($this.QuickReply.KeyWord.length>30){
				$this.$message.error('快捷词不能超过30字符')
				boole = false
			} 
			else if ($this.QuickReply.Content == '') {
				$this.$message.error('请输入回复内容')
				boole = false
			}
			if (boole) {
				$this.QuickReply.KeyWord = '#' + $this.QuickReply.KeyWord
				this.axios
					.post('QuickReply/AddQuick', $this.QuickReply, {
						headers: { 'Content-Type': 'application/json' }
					})
					.then(function(data) {
						if (data.data.message == '成功') {
							$this.$message(data.data.message)
							$this.QuickReply.KeyWord = ''
							$this.QuickReply.Content = ''
							$this.QuickReply.GroupId = 1
							$this.dialogVisible = false
							$this.QuickReply.GroupId = $this.options[0].id
							$this.List(1)
						} else {
							$this.$message.error(data.data.message)
						}
					})
			}
		},
		show() {
			let $this = this
			this.axios
				.get('QuickReplyGroup/Select', {
					'Content-Type': 'application/json'
				})
				.then(function(data) {
					$this.options = data.data
					$this.QuickReply.GroupId = $this.options[0].id
				})
		},
		AddShow() {
			let $this = this
			$this.dialogVisible = true
			$this.UpdateModelUpdate = '添加新的快捷回复'
		},
		//弹框
		UpdateShow(Id) {
			let $this = this
			$this.UpdateModelUpdate = '修改新的快捷回复'
			$this.dialogVisible = true
			$this.UpdateModel = true

			$this.axios
				.get(
					'QuickReply/UpdateModel',
					{
						params: { Id: Id }
					},
					{
						headers: {
							'Content-Type': 'application/json'
						}
					}
				)
				.then(function(data) {
					$this.QuickReply.Id = data.data.id
					$this.QuickReply.KeyWord = data.data.keyWord
					$this.QuickReply.Content = data.data.content
					$this.QuickReply.GroupId = data.data.groupId
				})
		},
		Clear() {
			let $this = this

			$this.dialogVisible = false
			$this.QuickReply.Id = 0
			$this.QuickReply.KeyWord = ''
			$this.QuickReply.Content = ''
			$this.QuickReply.GroupId = $this.options[0].id
		},
		UPdate() {
			let $this = this

			this.axios
				.post('QuickReply/Edit', $this.QuickReply, {
					headers: {
						'Content-Type': 'application/json'
					}
				})
				.then(function(data) {
					if (data.data.message == '成功') {
						$this.$message(data.data.message)
						$this.Total()
						$this.List(1)
						$this.show()
						$this.dialogVisible = false
					} else {
						$this.$message.error(data.data.message)
					}
				})
		},
		//删除
		Delete(Id) {
			let $this = this
			var mymessage = confirm('是否删除?')
			if (mymessage == true) {
				this.axios
					.post('QuickReply/delete?id=' + Id, {
						headers: {
							'Content-Type': 'application/json'
						}
					})
					.then(function(data) {
						if (data.data.message == '成功') {
							$this.$message(data.data.message)
							$this.Total()
							$this.List(1)
							$this.show()
						} else {
							$this.$message.error(data.data.message)
						}
					})
			} else {
			}
		},
		selectCheck(selection, row) {
			let $this = this
			$this.DeleteFastreply = []
			selection.forEach(element => {
				var elem = element.ID
				$this.DeleteFastreply.push(elem)
			})

			if ($this.DeleteFastreply.length > 0) {
				$this.iSdelete = false
			} else {
				$this.iSdelete = true
			}
		},
		select_allCheckk(selection) {
			let $this = this

			$this.DeleteFastreply = []
			selection.forEach(element => {
				var elem = element.ID
				$this.DeleteFastreply.push(elem)
			})

			if ($this.DeleteFastreply.length > 0) {
				$this.iSdelete = false
			} else {
				$this.iSdelete = true
			}
		},
		//选中的删除
		CheckDelete() {
			let $this = this
			$this.UpdateModelUpdate = '添加新的快捷回复'

			var mymessage = confirm('是否删除?')
			if (mymessage == true) {
				this.axios
					.post('QuickReply/deletes', $this.DeleteFastreply, {
						headers: {
							'Content-Type': 'application/json'
						}
					})
					.then(function(data) {
						if (data.data.message == '成功') {
							$this.$message(data.data.message)
							$this.Total()
							$this.List(1)
							$this.show()
						} else {
							$this.$message.error(data.data.message)
						}
					})
			} else {
			}
		},
		//导入
		tolead() {
			let str = document.getElementsByClassName('el-upload__input')
			console.log(str)
			str[0].click()
		},
		//导出
		export1() {
			let vm = this

			var GroupId1 = vm.quickRequest.groupId

			//debugger
			// alert(vm.value1)
			// alert(GroupId1)
			// QuickReply/exportQuickReply
			this.axios
				.post(
					'QuickReply/export?KeyWord=' +
						vm.value1 +
						'&GroupId=' +
						GroupId1,
					{},
					{
						responseType: 'blob' //设置响应的数据类型为一个包含二进制数据的 Blob 对象，必须设置！！！
					}
				)
				.then(function(res) {
					//debugger
					let filename = '快捷回复.xls'
					let blob = res.data
					let reader = new FileReader()
					reader.readAsDataURL(blob)
					reader.onload = e => {
						//创建a标签，插入到文档中并click，最后移除
						let a = document.createElement('a')
						a.download = filename
						a.href = e.target.result
						document.body.appendChild(a)
						a.click()
						document.body.removeChild(a)
					}
				})

			//    let $this=this;

			//    this.axios.post("QuickReply/export?KeyWord="+$this.value1,{
			//      responseType:'blob'
			//    }).then(function(res){
			// 	debugger
			// let filename = '快捷回复.xls'
			//  let blob = res.data
			// let reader = new FileReader()
			// // console.log(blob);
			// reader.readAsDataURL(res.data)
			// reader.onload = e => {
			// 	//创建a标签，插入到文档中并click，最后移除
			// 	let a = document.createElement('a')
			// 	a.download = filename
			// 	a.href = e.target.result
			// 	document.body.appendChild(a)
			// 	a.click()
			// 	document.body.removeChild(a)
			// }
			//    })
		},
		choose(emoItem) {
			this.QuickReply.Content += emoItem.emoji
			this.show4 = false
		}
	}
}
</script>

<style scoped>
#emoji1 {
	position: absolute;
	background: #fff;
	width: 450px;
	height: 150px;
	border: 1px solid #ebeef5;
	padding: 12px;
	z-index: 2000;
	color: #606266;
	line-height: 1.4;
	text-align: justify;
	font-size: 14px;
	-webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	word-break: break-all;
	bottom: 45px;
}
#emoji1 .el-tabs__content span {
	width: 30px;
	height: 30px;
	cursor: pointer;
	display: inline-block;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	font-style: normal;
	font-size: 20px;
}
.content-tit {
	line-height: 20px;
	display: flex;
	display: -webkit-flex;
	justify-content: space-between;
	align-items: center;
	padding-bottom: 5px;
}
.content-tit h2 {
	font-size: 20px;
	line-height: 30px;
	font-weight: normal;
	float: left;
}
.flex-box {
	width: 100%;
}
.add {
	float: right;
}
.import {
	float: right;
}
.export {
	float: right;
	margin-right: 10px;
}
.delete {
	float: right;
	margin-right: 10px;
}
.pagination {
	text-align: right;
}
.el-pagination {
	text-align: right;
	margin-top: 50px;
	display: inline-block;
}

.label {
	float: left;
	width: 120px;
	text-align: right;
	margin-right: 20px;
}
.section {
	line-height: 50px;
	margin-top: 10px;
}
.input_box {
	float: left;
	width: 60%;
}
.input_box .input {
	width: 100%;
}
.table_box {
	margin-top: 50px;
}
</style>
<style>
.reply .el-input-group {
	float: right;
	width: 320px;
}
.reply .el-textarea__inner {
	height: 100px;
	background-color: #fafafa;
}
.service {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	position: relative;
	height: 100%;
	overflow-x: hidden;
}
.custom-tree-node {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 14px;
	padding-right: 8px;
}
.custom-tree-node i {
	margin-right: 5px;
}
</style>




// WEBPACK FOOTER //
// src/components/manage/setting/reply.vue